import service from "@/store/services/reseller-invoices-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  resellerInvoice: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, resellerInvoice) => {
    state.resellerInvoice = resellerInvoice;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((resellerInvoice) => {
      commit("SET_RESOURCE", resellerInvoice);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((resellerInvoice) => {
      commit("SET_RESOURCE", resellerInvoice);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((resellerInvoice) => {
      commit("SET_RESOURCE", resellerInvoice);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((resellerInvoice) => {
      commit("SET_RESOURCE", resellerInvoice);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((resellerInvoice) => {
      commit("SET_RESOURCE", resellerInvoice);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  resellerInvoice: (state) => state.resellerInvoice,
  url: (state) => state.url,
};

const resellerInvoices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default resellerInvoices;
